import * as zod from 'zod';

export const LEDStateSchema = zod.enum([
  'Idle',
  'MovingFast',
  'MovingSlow',
  'Failure',
  'Antigravity',
  'AntigravitySlow',
  'BrakesEngaged',
  'RecoveryMode',
  'RoutineAntigravity',
]);

export type LEDState = zod.infer<typeof LEDStateSchema>;
